import request from '@/utils/request'

// 取得 Authorization
export function fetchResourceList(data) {
  return request({
    url: '/Resource/list',
    method: 'post',
    data: {
      Data: data
    }
  })
}

